// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1011":"df9225ae","1300":"8afeee2a","2481":"8afeee2a","3935":"e049a95b","5747":"e049a95b","8140":"28fb3392","9453":"8afeee2a"}[chunkId] + ".chunk.css";
};